export default "__VITE_ASSET__D4nL9vz2__"